package one.healthium.today.ui.period_tracker

import one.healthium.today.ui.models.PeriodTrackerUiModel
import androidx.compose.runtime.Immutable

@Immutable
data class PeriodTrackerUiState (
    val uiModel: PeriodTrackerUiModel,
)
